module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAgCAIAAABVbCU3AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAA/SURBVChTY3j2+W/ypo8ms98ASSCbAUhpTnsNQUA2A1AGzgeyMeQh+g1mgjgg/f/BYN/9nxDGKB8MBin//38AVJi6BUWrlnUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/memorabiliaMini.png
// module id = b6zE
// module chunks = 1